
import "waypoints/lib/noframework.waypoints";
import Swiper from "swiper/swiper-bundle";
import {Modal, Collapse, Dropdown } from "bootstrap";
import Typed from 'typed.js';

(function ($, window) {
  const api = {};
  api.init = function () {
    $("html").removeClass("no-js");


    $(".logos_slider .swiper").each(function (i, elem) {
      const swiper = new Swiper(elem, {
        slidesPerView: 1,
        spaceBetween: 0,
        autoplay: true,
        breakpoints: {
          992: {
            slidesPerView: 3,
            spaceBetween: 0,
          },
          1600: {
            slidesPerView: 3,
            spaceBetween: 0,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    });

    $(".play-video").on("click", function (e) {
      e.preventDefault();
      var $this = $(this);
      let video = $this.prev()[0];
      video.play();
      video.controls = true;
      $this.addClass('hide');
    });

    const waypoints = document.querySelectorAll(
      ".waypoint"
    );

    [...waypoints].forEach(function (element, index) {
      new Waypoint({
        element,
        handler: function (direction) {
          this.element.classList.add("on-screen");
        },
        offset: "70%",
      });
    });



    $('[data-text]').each(function (i, element) {
      let $element = $(element);
      let text = $element.data("text").split('|');

      $element.text('');
      new Typed(element, {strings: text, typeSpeed: 50, backSpeed: 20, loop: true, backDelay: 2000});
    });
  };

  api.onScroll = function (e) {
    $('#scroll-top').toggleClass('show', window.scrollY > 300);
  };
  //document ready
  $(function () {
    api.init();
  });

  window["page"] = api;

  $(window).on("scroll", api.onScroll);
})(jQuery, window);
